<template>
    <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 pb-4"
    >
        <div
            v-for="index in 8"
            :key="index"
            class="relative bg-white border border-slate-200 rounded-lg shadow-sm p-4 flex flex-col animate-pulse space-y-4"
        >
            <div class="flex items-start justify-between">
                <div class="flex items-start space-x-3">
                    <div class="h-16 w-16 rounded-full bg-slate-200"></div>
                    <div class="flex flex-col space-y-3">
                        <div class="h-4 w-32 bg-slate-200 rounded"></div>
                        <div class="h-3 w-20 bg-slate-200 rounded"></div>
                    </div>
                </div>
                <div class="flex">
                    <div class="h-[22px] w-[25px] bg-slate-300 rounded-l"></div>
                    <div class="h-[22px] w-[50px] bg-slate-200 rounded-r"></div>
                </div>
            </div>

            <div class="flex gap-2">
                <div class="h-5 w-5 rounded bg-slate-200"></div>
                <div class="h-5 w-5 rounded bg-slate-200"></div>
                <div class="h-5 w-5 rounded bg-slate-200"></div>
                <div class="h-5 w-5 rounded bg-slate-200"></div>
            </div>

            <div class="grid grid-cols-3 gap-4 text-sm">
                <div class="space-y-3 mt-4">
                    <div class="h-3 w-12 bg-slate-200 rounded"></div>
                    <div class="h-4 w-16 bg-slate-300 rounded"></div>
                </div>
                <div class="space-y-3 mt-4">
                    <div class="h-3 w-12 bg-slate-200 rounded"></div>
                    <div class="h-4 w-16 bg-slate-300 rounded"></div>
                </div>
                <div class="space-y-3 mt-4">
                    <div class="h-3 w-12 bg-slate-200 rounded"></div>
                    <div class="h-4 w-16 bg-slate-300 rounded"></div>
                </div>
            </div>

            <div class="border-t border-slate-100 pt-3 space-y-3">
                <div class="h-3 w-32 bg-slate-200 rounded"></div>
                <div class="h-3 w-full bg-slate-200 rounded"></div>
                <div class="h-3 w-5/6 bg-slate-200 rounded"></div>
            </div>

            <div class="border-t border-slate-100 pt-3 space-y-3">
                <div class="h-3 w-32 bg-slate-200 rounded"></div>
                <div class="h-3 w-5/6 bg-slate-200 rounded"></div>
                <div class="h-3 w-5/6 bg-slate-200 rounded"></div>
                <div class="h-3 w-5/6 bg-slate-200 rounded"></div>
            </div>

            <div class="border-t border-slate-100 pt-3 mt-auto">
                <div class="h-8 w-24 bg-slate-300 rounded ml-auto"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonAIInfluencerCards',
}
</script>
